import {Pipe, PipeTransform} from '@angular/core';
import {TranslateService} from "@ngx-translate/core";

@Pipe({
  name: 'serviceType'
})
export class ServiceTypePipe implements PipeTransform {

  constructor(private translateService: TranslateService) {
  }

  transform(value: number): any {
    switch (value) {
      case 1: {
        return this.translateService.instant('video-consultation')
      }
      case 2: {
        return this.translateService.instant("doctor's-visit")
      }
      case 3: {
        return this.translateService.instant('phone-consultation')
      }
    }
  }

}
